import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f50a817a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=f50a817a&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=f50a817a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50a817a",
  null
  
)

export default component.exports